import { render } from "./checkbox.vue?vue&type=template&id=2d3cb404"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"

import "./checkbox.vue?vue&type=style&index=0&id=2d3cb404&lang=scss"

import exportComponent from "/home/runner/work/MBx/MBx/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__